//Global External Imports
import { useTranslation } from "react-i18next";
import React, { useEffect, useState, Fragment } from "react";
import {
  Button,
  Grid,
  Card,
  Box,
  TextField,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableContainer,
  Paper,
  TableCell,
  IconButton,
  Fab,
  Popover,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { Routes, Route } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../../constants/apiConstants";
import openFile from "../shared/functions/download";
//Global Internal Imports
import apiRequest from "../../functions/api";
import { useMessage } from "../../context/message-context";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import Formular from "../Formular/Formular";
import FormularEingabe from "../Formulare/FormularEingabe";
import { FullPageSpinner } from "../lib";
import ResponsiveDialog from "../shared/components/ResponsiveDialog";
import MessageBox from "../shared/components/MessageBox";
import { formatDate } from "../../functions/formatDate";
import { Visibility } from "@mui/icons-material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
//Child Imports
function FormularGenehmigen(props) {
  const { t } = useTranslation();
  //Standardfelder
  const { client, accessToken, formularKeyProps } = props;
  const formularkey = useParams()?.formularkey ?? formularKeyProps;
  const [isLoading, setIsLoading] = useState(false);
  const { showErrorMessage, showSuccessMessage } = useMessage();
  const navigate = useNavigate();
  const [formular, setFormular] = useState();
  const [formularBez, setFormularBez] = useState("");
  const [formularStatus, setFormularStatus] = useState("");
  const [felder, setFelder] = useState({});
  const [hper, setHper] = useState({});
  const [stammfelder, setStammfelder] = useState({});
  const [listeFormular, setListeFormular] = useState([]);
  const [uebergaben, setUebergaben] = useState({});
  const [dbliste, setDbliste] = useState([]);
  const [felderError, setFelderError] = useState([]);
  const [newkey, setNewkey] = useState();
  const [files, setFiles] = useState([]);
  const [buttons, setButtons] = useState("");
  const [loading, setLoading] = useState(false);
  const [bem, setBem] = useState(false);
  const [info, setInfo] = useState(false);
  const [bemerkung, setBemerkung] = useState("");
  const [ueberschneidungen, setUeberschneidungen] = useState([]);
  const [lohnarten, setLohnarten] = useState([]);
  const [selectedKonto, setSelectedKonto] = useState();
  const [selectedKontoLusdKey, setSelectedKontoLusdKey] = useState();
  const [selectedLusdMonat, setSelectedKontoLusdMonat] = useState();
  const [ankeyRes, setAnKEyRes] = useState();

  const [folgeformular, setFolgeformular] = useState("");

  const [anchorEl, setAnchorEl] = React.useState(null);

  //State wird ín Saldenauszahlung.js verwaltet und hat den Sinn das Absenden von Anträgen zu verhindern, wenn in dem LohnZR bereits für das Konto eine Auszahlung beantragt wurde
  //State wird ebenso verwendet, wenn bei einer Saldenauszahlung ein Konto einen negativen Wert hat -> Buttons müssen disabled werden
  const [saldenauszahlungDisableButtons, setSaldenauszahlungDisableButtons] = useState(false);

  const handleFabClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  //PVX Kommunikation
  useEffect(() => {
    setIsLoading(true);
    const payload = {
      mandant: client,
      program: "PMURA3",
      statement: "FORMULAR_LADEN",
      formularkey: formularkey,
      formular: formularkey?.substr(7, 3),
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, (r) => postLaden(r));

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (newkey && newkey.length && newkey.length > 15) {
      navigate("/FORMUL/genehmigen/" + formularkey + "/bearbeitung/" + newkey);
    }
  }, [newkey]);
  function postLaden(response) {
    setIsLoading(false);
    if (response.status === 200) {
      setUeberschneidungen(response.data?.preview?.ueberschneidungen);
      setLohnarten(response.data?.preview?.lohnarten);
      setFormular("F" + formularkey.substr(7, 3));
      setFelder(response.data.felder);
      setDbliste(response.data.dbliste);
      setHper(response.data.hper);
      setStammfelder(response.data.stammfelder);
      setFormularBez(response.data.formularbez);
      setFormularStatus(response.data.status);
      if (response.data.bemerkung) setBemerkung(response.data.bemerkung);
      if (response.data.buttons) setButtons(response.data.buttons);
      if (response.data.folgeformular) setFolgeformular(response.data.folgeformular);
      ListeAufbauen(response.data.felder, response.data.stammfelder, "F" + formularkey.substr(7, 3));
      if (response.data.uebergaben) setUebergaben(response.data.uebergaben);
      setAnKEyRes(response.data.ankey);
      //Im Fall Saldenauszahlung
      // Prüft, ob ein "P"-Feld existiert, das ein "felderAntworten"-Objekt mit einem "selectedKonto" enthält,
      // und setzt den Key des "selectedKonto" in den State, wenn gefunden.
      if (response.data.felder && response.data.felder["F" + formularkey.substr(7, 3)]) {
        const felder = response.data.felder["F" + formularkey.substr(7, 3)];
        Object.values(felder).forEach((feld) => {
          if (feld.art === "P" && feld.felderAntworten && feld.felderAntworten.selectedKonto) {
            setSelectedKonto(feld.felderAntworten.selectedKonto.key);
            setSelectedKontoLusdKey(feld.felderAntworten.selectedKonto.lusdKey);
            setSelectedKontoLusdMonat(feld.felderAntworten.selectedKonto.lusdMonat);
            console.log(feld.felderAntworten.selectedKonto);
          }
        });
      }
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  }
  function DateiLaden(key, art) {
    setLoading(true);
    const payload = {
      mandant: client,
      program: "PMURA3",
      statement: "DATEI_LADEN",
      key: key,
      art: art,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
      Accept: "application/pdf",
    };
    axios
      .post(API_BASE_URL + "daten", payload, { headers: headers, responseType: "blob" })
      .then((response) => {
        var fileName = "Datei" + ".pdf";
        var contentFile = response.data;
        openFile(fileName, contentFile);
        setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
        showErrorMessage(t("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."));
      });
  }
  //Standardfunktionen
  if (isLoading) {
    return <LoadingComponent path={props.location} />;
  }
  function Reload() {
    navigate(-1);
  }
  function ListeAufbauen(tmpfelder, tmpstammfelder, tmpformular) {
    if (!tmpfelder[tmpformular]) return;
    var inhalt = tmpfelder[tmpformular][tmpformular].inhalt.split(";");
    var i;
    var tmpliste = [];
    for (i = 0; i < inhalt.length; i++) {
      if (inhalt[i] === "") continue;
      if (!tmpfelder[tmpformular][inhalt[i]] && !tmpstammfelder[inhalt[i]]) continue;
      tmpliste.push(inhalt[i]);
    }
    setListeFormular(tmpliste);
  }
  function ChangeFelder(id, value, newfelder) {
    //setFelder(newFelder)
    setFelder(JSON.parse(JSON.stringify(newfelder)));
  }
  function ChangeFiles(newFile) {
    var tmpliste = files;
    tmpfiles.push(newFile);
    setFiles(tmpliste);
  }
  function FormularGenehmigen() {
    const payload = {
      mandant: client,
      program: "PMURA3",
      statement: "FORMUL_GENEHMIGEN",
      formularkey: formularkey,
    };

    // Überprüfe, ob ein Wert im State selectedKonto enthalten ist
    if (selectedKonto) {
      // Wenn ja, füge den saldenKontoKey zur Payload hinzu
      payload.saldenKontoKey = selectedKonto;
      payload.saldenKontoKeyLusd = selectedKontoLusdKey;
      payload.saldenKontoMonat = selectedLusdMonat;
    }

    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, (r) => postBearbeitung(r));
  }
  console.log("selectedKonto", selectedKonto);
  function FormularAblehnen() {
    const payload = {
      mandant: client,
      program: "PMURA3",
      statement: "FORMUL_ABLEHNEN",
      formularkey: formularkey,
      bemerkung: bemerkung,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, (r) => postBearbeitung(r));
  }
  function postBearbeitung(response) {
    if (response.status === 200) {
      showSuccessMessage(t("Formular bearbeitet"));
      navigate(-1);
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  }
  function FormularBearbeiten() {
    const payload = {
      mandant: client,
      program: "PMURA3",
      statement: "FORMUL_BEARBEITEN",
      formularkey: formularkey,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, (r) => postBearbeiten(r));
  }
  function postBearbeiten(response) {
    if (response.status === 200) {
      setNewkey(response.data.key);
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  }
  function Zurueck() {
    if (folgeformular) {
      setInfo(true);
    } else {
      setBem(true);
    }
  }
  function CheckZurueck() {
    setBem(false);
    FormularAblehnen();
  }
  function PostInfo(r) {
    setInfo(false);
    if (r === "YES") {
      setBem(true);
    }
  }
  function FormularPDF(key) {
    setLoading(true);
    const payload = {
      mandant: client,
      program: "PMURA3",
      statement: "PDF_LADEN",
      key: key,
      saldenauszahlungGenehmigenKz: true,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
      Accept: "application/pdf",
    };
    axios
      .post(API_BASE_URL + "daten", payload, { headers: headers, responseType: "blob" })
      .then((response) => {
        var fileName = "Formular.pdf";
        var contentFile = response.data;
        openFile(fileName, contentFile);
        setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
        showErrorMessage(t("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."));
      });
  }
  //Renderfunktionen
  //Rückgabe
  const actionButtons = (
    <Box p={3}>
      <Card>
        <Box p={2}>
          <Grid container justifyContent="center" spacing={2}>
            {buttons?.includes("G") && !["G", "X"].includes(formularStatus) && (
              <Grid item xs={12}>
                <Button
                  disabled={saldenauszahlungDisableButtons}
                  fullWidth
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    FormularGenehmigen();
                  }}
                >
                  {t("Formular genehmigen")}
                </Button>
              </Grid>
            )}
            {buttons?.includes("Z") && !["G", "X"].includes(formularStatus) && (
              <Grid item xs={12}>
                <Button
                  disabled={saldenauszahlungDisableButtons}
                  fullWidth
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    Zurueck();
                  }}
                >
                  {t("Formular Zurückschicken")}
                </Button>
              </Grid>
            )}
            {buttons?.includes("B") && !["G", "X"].includes(formularStatus) && (
              <Grid item xs={12}>
                <Button
                  fullWidth
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    FormularBearbeiten();
                  }}
                >
                  {t("Formular bearbeiten")}
                </Button>
              </Grid>
            )}
            <Grid item xs={12}>
              <Button
                fullWidth
                variant="outlined"
                color="primary"
                onClick={() => {
                  FormularPDF(formularkey);
                }}
              >
                {t("Formular in PDF")}
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Button
                fullWidth
                variant="outlined"
                color="primary"
                onClick={() => {
                  DateiLaden("komplett" + formularkey);
                }}
              >
                {t("Alle Belege in PDF")}
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Card>
    </Box>
  );
  function Uebersicht() {
    return (
      <Fragment>
        <ResponsiveDialog
          title={t("Grund")}
          open={bem}
          setOpen={() => {
            setBem(false);
          }}
          actionButton={
            <Fragment>
              <Grid container spacing={2} justifyContent="flex-end">
                <Grid item>
                  <Button variant="outlined" color="primary" onClick={() => setBem(false)}>
                    {t("Abbrechen")}
                  </Button>
                </Grid>
                <Grid item>
                  <Button variant="outlined" color="primary" onClick={() => CheckZurueck()}>
                    {t("Zurückschicken")}
                  </Button>
                </Grid>
              </Grid>
            </Fragment>
          }
        >
          <Box p={2}>
            <Grid container justifyContent="center" spacing={2}>
              <Grid item xs={10}>
                <TextField
                  id="comment"
                  label={t("Grund für das Zurücksenden")}
                  multiline
                  fullWidth
                  helperText={bemerkung.length + "/200"}
                  value={bemerkung}
                  inputProps={{ maxLength: 200 }}
                  onChange={(e) => setBemerkung(e.target.value)}
                  variant="outlined"
                />
              </Grid>
            </Grid>
          </Box>
        </ResponsiveDialog>
        <Grid container justifyContent="center" spacing={0}>
          <Grid item xs={12}></Grid>
        </Grid>
        <Grid container justifyContent="flex-start" spacing={0}>
          <Grid item xs={12} md={2} display={{ xs: "none", md: "block" }}>
            {actionButtons}
          </Grid>
          {ueberschneidungen?.length > 0 && (
            <>
              <Grid item xs={12} md={10} p={0}>
                <Typography variant="h4" color={"red"}>
                  Achtung !
                </Typography>
                <Typography>Es liegen bereits genehmigte Formulare mit einem überschneidenden Zeitraum vor</Typography>

                <Box p={1}>
                  <TableContainer component={Paper}>
                    <Table aria-label="spanning table">
                      <TableHead>
                        <TableRow>
                          <TableCell>Formular</TableCell>
                          <TableCell>Zeitraum</TableCell>
                          <TableCell>Status</TableCell>
                          <TableCell width={"5%"}></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {ueberschneidungen.map((formular) => (
                          <TableRow>
                            <TableCell>{formular.bezeichnung}</TableCell>
                            <TableCell>
                              {formatDate(formular.von, "YYYYMMDD", "DD.MM.YYYY")}- {formatDate(formular.bis, "YYYYMMDD", "DD.MM.YYYY")}
                            </TableCell>
                            <TableCell>{formular.status}</TableCell>
                            <TableCell>
                              <IconButton
                                color="primary"
                                onClick={() => {
                                  FormularPDF(formular.key);
                                }}
                              >
                                <Visibility />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Grid>
              <Grid item md={2}></Grid>
            </>
          )}
          <Grid item xs={12} md={10}>
            <div id="formular">
              <Formular
                key={felder[formular]}
                bez={formularBez}
                formular={formular}
                liste={listeFormular}
                felder={felder}
                stammfelder={stammfelder}
                hper={hper}
                ChangeFelder={ChangeFelder}
                uebergaben={uebergaben}
                felderError={felderError}
                lock={true}
                ChangeFiles={ChangeFiles}
                files={files}
                DateiLaden={DateiLaden}
                bemerkung={bemerkung}
                dbliste={dbliste}
                program="PMURA3"
                setSaldenauszahlungDisableButtons={setSaldenauszahlungDisableButtons}
                client={client}
                accessToken={accessToken}
                genehmigen={true}
                ankeyRes={ankeyRes}
              />
            </div>
          </Grid>
        </Grid>
        <div>
          <Fab
            color="primary"
            aria-label="add"
            size="small"
            sx={{
              position: "fixed",
              bottom: 20,
              right: 20,
              justifyContent: "center",
              display: { xs: "block", md: "none" },
            }}
            onClick={handleFabClick}
          >
            <MoreVertIcon sx={{ marginTop: "5px" }} />
          </Fab>
          <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <Card>{actionButtons}</Card>
          </Popover>
        </div>

        <Grid container justifyContent="flex-end" spacing={1} paddingBottom={5}>
          <Grid item xs={12} md={10}>
            <Box p={3}>
              <Card>
                <Box p={2}>
                  <Grid container justifyContent="center" spacing={2}>
                    {buttons?.includes("G") && !["G", "X"].includes(formularStatus) && (
                      <Grid item xs={12} md={6}>
                        <Button
                          disabled={saldenauszahlungDisableButtons}
                          fullWidth
                          variant="outlined"
                          color="primary"
                          onClick={() => {
                            FormularGenehmigen();
                          }}
                        >
                          {t("Formular genehmigen")}
                        </Button>
                      </Grid>
                    )}
                    {buttons?.includes("Z") && !["G", "X"].includes(formularStatus) && (
                      <Grid item xs={12} md={6}>
                        <Button
                          disabled={saldenauszahlungDisableButtons}
                          fullWidth
                          variant="outlined"
                          color="primary"
                          onClick={() => {
                            Zurueck();
                          }}
                        >
                          {t("Formular Zurückschicken")}
                        </Button>
                      </Grid>
                    )}
                    {buttons?.includes("B") && !["G", "X"].includes(formularStatus) && (
                      <Grid item xs={12} md={6}>
                        <Button
                          fullWidth
                          variant="outlined"
                          color="primary"
                          onClick={() => {
                            FormularBearbeiten();
                          }}
                        >
                          {t("Formular bearbeiten")}
                        </Button>
                      </Grid>
                    )}
                  </Grid>
                </Box>
              </Card>
            </Box>
          </Grid>
        </Grid>
        {loading && <FullPageSpinner />}
        <MessageBox
          title={t("Info Zurückschicken")}
          text={t("Es existiert bereits ein Folgeformular. Dieses wird beim Zurückschicken automatisch mit zurückgesetzt! Möchten Sie fortfahren?")}
          buttons="YESNO"
          onClose={() => setInfo(false)}
          open={info}
          handleResponse={(r) => PostInfo(r)}
        />
      </Fragment>
    );
  }
  return (
    <Routes>
      <Route
        path="/bearbeitung/:formularnummer"
        element={
          <FormularEingabe
            edit={true}
            key={newkey}
            client={client}
            accessToken={accessToken}
            formular={"F" + String(newkey).substr(7, 3)}
            formularkey={newkey}
            Reload={Reload}
            setFormular={() => {}}
            setFormularkey={setNewkey}
          />
        }
      />
      <Route path="/" element={Uebersicht()} />
    </Routes>
  );
}
export default FormularGenehmigen;
